import { Card, Col, Row } from "antd";
import increase from 'assets/increase.svg';
import { BoothSalesperMonthBoothWise } from "features/dashboard/components/booth-sales/Booth-sales";
import { BoothSalesCategoryView } from "features/dashboard/components/booth-sales/category-sales";
import { PopularBoothSoldView } from "features/dashboard/components/booth-sales/Popular-sold";
import { DashboardHeader } from "features/dashboard/components/top-bar/Dashboard-header";
import { Fragment } from "react/jsx-runtime"
import { useLocation } from "react-router-dom";

export const BoothSales = () => {
    const location = useLocation();
    const pathnameWithoutDashboard = location.pathname.replace('/dashboard/', '');
    const cardData = [
        {
            icon: increase,
            label: "Total Items Sold",
            value: "1000",
        },
        {
            icon: increase, // Replace with actual icon
            label: "Total Revenue",
            value: "KWD 10000",
        },
        {
            icon: increase, // Replace with actual icon
            label: "Total Cost",
            value: "KWD 10000",
        },
        {
            icon: increase, // Replace with actual icon
            label: "Total Profit",
            value: "KWD 10000",
        },
    ];
    
return (
        <Fragment>
            <DashboardHeader title={pathnameWithoutDashboard} />
            <Row gutter={[16, 16]}>
                {cardData.map((item, index) => (
                    <Col span={6} key={index}>
                        <div className="sales_regis">
                            <Card>
                                <img src={item.icon} alt="" width={20} height={20} />
                                <p>{item.label}</p>
                                <h2>{item.value}</h2>
                            </Card>
                        </div>
                    </Col>
                ))}
            </Row>
            <Row className="graph_row">
                <Col span={12}>
                    <BoothSalesCategoryView />
                </Col>
                <Col span={12}>
                    <PopularBoothSoldView />
                </Col>
                <Col span={12}>
                    <BoothSalesperMonthBoothWise />
                </Col>
            </Row>
        </Fragment>
    )
}